module.exports = __webpack_public_path__ + "img/贵州省地质灾害防治指挥平台.1de56b1a.png";